/* eslint-disable */

import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import '~styles/modules/maplistbuilder.scss';
import originalMapData from '../../assets/data/final_map_data.json';


let categories = ["shopping", "entertainment", "food", "outdoors"];
let itemIdSuffix = "-description-container";
let mapListItemsClass = "map-entry-containers";
let pointActive = false;

const MapListBuilder = ({ dataSource }) => {

  React.useEffect(() => {
    // if (typeof document !== `undefined`) { 
    //   let allListItems = document.getElementsByClassName(mapListItemsClass);
    //   let allMarkers = document.getElementsByClassName('markers')
    //   console.log("a "+ allListItems)
    //   console.log("b "+ allMarkers)

    //   for (let i = 0; i < allListItems.length; i++ ){
    //     let currentItem = allListItems[i];
    //     console.log("c "+ currentItem)
    //     currentItem.addEventListener('mouseenter', function() {
    //     console.log("d "+ allMarkers)
    //       for (let m = 0; m < allMarkers.length; m++ ){
    //         console.log("e "+ m)
    //         console.log("f "+ allMarkers[m].dataset)
    //         console.log("fa"+ allMarkers[m].dataset.join)
    //         console.log("fb "+ this.id)
    //         if(allMarkers[m].dataset.join==(this.id)){
    //           console.log("g "+ document.getElementById(allMarkers[m].id))
    //           show(allMarkers[m].id)
    //           break
    //         }
    //       }
    //     })

    //   }

    // }
  }, []);

  //to pre-load points
  //dataSource =  originalMapData;

  let list = dataSource.map((item) => {
    return (
      <div className="map-entry-containers" id={item.Unique_Slug+"-description-container"}>
        <div className="map-entry-category">{item.Color.toUpperCase()}</div>
        <div className="map-entry-name">{item.Name}</div>
        <div className="map-entry-address">{item.Address}</div>
        <div className="map-entry-neighborhood">Neighborhood: <strong>{item.Neighborhood}</strong></div>
        <div className="map-entry-audience">Audience: <strong>{item.Audience}</strong></div>
        <div className="map-entry-website"><strong><a href={item["Place URL"]} target="_blank">Website: {item["Place URL"]}</a></strong></div>
        <div className="map-entry-description">{item.Comments}</div>
      </div>
    );
  });

  //Default message for no items
  if(dataSource.length==0){
    return(
      <div id="map-list-container">
        <div className="map-entry-containers" id="empty-map-message">
          Nothing here yet. Use the filter above to show recommendations on the map.
        </div>
      </div>
    )
  }else{ 
    return (
      <div id="map-list-container"> {list}</div>
    );
  };
};




export default MapListBuilder;
